import { render, staticRenderFns } from "./SolicitarAnamneseDialog.vue?vue&type=template&id=44ccf45c&scoped=true"
import script from "./SolicitarAnamneseDialog.vue?vue&type=script&lang=js"
export * from "./SolicitarAnamneseDialog.vue?vue&type=script&lang=js"
import style0 from "./SolicitarAnamneseDialog.vue?vue&type=style&index=0&id=44ccf45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ccf45c",
  null
  
)

export default component.exports